/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Pit3_DInputs */

const en_viewer_pit3_d = /** @type {(inputs: Viewer_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON numbers are parsed as double precision floats, so an integer beyond 2^53 loses precision during parsing, before the tree is built. A twenty digit ID will display with trailing zeros that were not in your input. Check the raw editor for the original text, and ask the producer to send such IDs as strings.`)
};

const ko_viewer_pit3_d = /** @type {(inputs: Viewer_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 숫자는 배정밀도 부동소수점으로 파싱되므로, 2^53을 넘는 정수는 트리가 만들어지기 전인 파싱 과정에서 정밀도를 잃습니다. 스무 자리 ID는 입력에 없던 뒤쪽 0과 함께 표시됩니다. 원래 텍스트는 원문 에디터에서 확인하고, 그런 ID는 문자열로 보내달라고 생산자에게 요청하세요.`)
};

const ja_viewer_pit3_d = /** @type {(inputs: Viewer_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON の数値は倍精度浮動小数点としてパースされるので、2^53 を超える整数はツリーが作られる前、パースの段階で精度を失います。20 桁の ID は入力になかった末尾のゼロとともに表示されます。元のテキストは生のエディタで確認し、そうした ID は文字列で送るよう生成側に依頼してください。`)
};

/**
* | output |
* | --- |
* | "JSON numbers are parsed as double precision floats, so an integer beyond 2^53 loses precision during parsing, before the tree is built. A twenty digit ID wil..." |
*
* @param {Viewer_Pit3_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_pit3_d = /** @type {((inputs?: Viewer_Pit3_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Pit3_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_pit3_d(inputs)
	if (locale === "ko") return ko_viewer_pit3_d(inputs)
	return ja_viewer_pit3_d(inputs)
});